export const TOOL_COSTS = {
  affirmations: 20,
  soundCatalog: 40,
  beliefDetox: 30,
  chakraCleansing: 50,
  deepSleep: 70,
} as const
